import { FileUploadModule } from './DI/FileUploadModule';
import type { IUploadDispatcher } from './DI/interfaces';
import DITypes from './DI/types';

export { FileUploadModule, type IUploadDispatcher };
export const { UploadDispatcher } = DITypes;
